export default __webpack_public_path__ + "d88db7e753fe3a958f34c7adac94052c.png";